import { render, staticRenderFns } from "./cms-no-items-container.vue?vue&type=template&id=3f4164b2&scoped=true&"
import script from "./cms-no-items-container.vue?vue&type=script&lang=js&"
export * from "./cms-no-items-container.vue?vue&type=script&lang=js&"
import style0 from "./cms-no-items-container.vue?vue&type=style&index=0&id=3f4164b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4164b2",
  null
  
)

export default component.exports